exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-opening-hours{padding:16px;border:1px solid rgba(0,0,0,.12);margin-bottom:16px}.sb-opening-hours md-input-container{margin-bottom:0}.sb-opening-hours .md-button{margin:0}.input-search{margin-left:auto}.md-button.md-accent.md-raised.button-spin-active{background:#fff;color:#d50000;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.button-loader{display:inline-block;vertical-align:middle;margin-left:5px}.sb-content-container .image-container{margin-bottom:40px}.sb-content-container .image-container .sb-page-section-title{margin-left:0;color:rgba(0,0,0,.54)}.sb-content-container .image-container .md-button{margin:0}.sb-content-container .sb-unit-image-container{margin-left:40px;margin-bottom:30px}.sb-content-container .sb-unit-image-container .sb-unit-image{max-width:180px}.sb-page-section-sub-title-schedules{color:#f44336!important;font-size:12px!important;font-weight:700;margin:-12px 0 10px 16px!important;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/unit/unit.scss
// module id = 626
// module chunks = 0